import axios from "axios";

const actions = {
  async getAllEmployeeTags({ commit }) {
    const res = await axios.get("employeeTag");

    const tags = res.data.data || res.data;

    commit("setAllEmployeeTags", tags);
    return tags;
  },
};

export default actions;
